<template>
  <HelloWorld msg="Hero Capital"/>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
// import LandingPage from './components/LandingPage.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
